import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading");
  useEffect(() => {
    api.get(`/public/reports/unsubscribe/${token}`).then((r) => { setInfo(r.data); setState(r.data.subscribed ? "ask" : "done"); }).catch(() => setState("invalid"));
  }, [token]);
  const confirm = async () => {
    await api.post(`/public/reports/unsubscribe/${token}`);
    setState("done");
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#F5F5F7] px-6">
      <div className="panel w-full max-w-md p-8 text-center" data-testid="unsubscribe-page">
        <div className="flex justify-center"><Logo size={28} /></div>
        {state === "ask" && <>
          <h1 className="mt-8 text-2xl font-semibold">Report mensile</h1>
          <p className="mt-3 text-sm text-zinc-500">Vuoi smettere di ricevere il report mensile per {info.name}?</p>
          <button onClick={confirm} className="mt-8 rounded-full bg-black px-6 py-3 text-sm font-medium text-white hover:bg-zinc-800" data-testid="unsubscribe-confirm">Non ricevere più il report</button>
        </>}
        {state === "done" && <p className="mt-8 text-sm text-zinc-600" data-testid="unsubscribe-done">Fatto. Non riceverai più il report mensile. Per riattivarlo contatta chi gestisce la tua card.</p>}
        {state === "invalid" && <p className="mt-8 text-sm text-zinc-600" data-testid="unsubscribe-invalid">Questo link non è valido.</p>}
      </div>
    </div>
  );
}
